import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LoadingProvider {

  public loading: Observable<boolean>;
  private $loading: Subject<boolean>;

  constructor() {
    this.$loading = new Subject<boolean>();
    this.loading = this.$loading.asObservable();
  }

  show(state: boolean): void {
    this.$loading.next(state);
  }

}



// WEBPACK FOOTER //
// ./src/providers/loading/loading.ts